import styled from '@emotion/styled'

import theme from 'styles/theme'

export const ImageWrapper = styled.div`
  min-width: 50px;
  width: 50px;
  height: 50px;
  border: 1px solid ${theme.token.var('colors.green.a50')};
  border-radius: ${theme.token.var('borderRadius.small')};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${theme.token.var('colors.white')};

  img {
    width: 90%;
    margin: 10px 0;
    height: 90%;
    object-fit: cover;
  }
`
